export default __webpack_public_path__ + "static/media/About_CommonMenu.77472a25.svg";